import { ReportIcon } from 'src/components/ui-icons/sidebar';
import { useNavigate } from 'react-router-dom';
import ChartLicense from '../chart-license/chart-license';
import { LabelsActions, LabelsPrescription } from '../../mocks/documents';
import PanelStatus from '../panel-status/panel-status';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { filterConfigReportPres, initialFilterOpenReportPres, initialFilterReportPres } from '../dataForFilters/reportPrescription/filtersDataReportPrescription';
import { modifiedItemsState } from 'src/modules/spItems/selectors';
import { isEqual } from 'lodash';
import FilterForPlanAction from 'src/pages/DashboardPage/vpo/components/planAction/filterForPlanAction/FilterForPlanAction';
import { myTaskActionsListName } from 'src/api/config/myTasksActions.config';
import { AdditionalFilters, FilterValue, SelectionFilterValue } from '../../types/typesGos';
import { getItemsRequest } from 'src/modules/spItems/api';
import { generatePrescriptions } from '../../utils/utils';
import { transformActionsToChartData, transformPrescriptionsToChartData } from '../../utils/reportPrescriptionChartData';
import { selectUsers } from 'src/modules/users/selector';
import { fetchData } from '../../store/filterData/actions';
import { selectModelData } from '../../store/filterData/selector';
import { transformDataForFilters, transformDataForFiltersInCode } from '../../utils/utilsGOS';
import React from 'react';

interface PrescriptionFilters {
  created?: any;
  responsible?: FilterValue;
  direction?: FilterValue;
  status?: FilterValue;
}

type FilterKey = keyof PrescriptionFilters;

function ReportPrescription() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [currentFilters, setCurrentFilters] = useState<PrescriptionFilters>(initialFilterReportPres);
  const [prevFilters, setPrevFilters] = useState<PrescriptionFilters>(initialFilterReportPres);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageViolations, setCurrentPageViolations] = useState(1);
  const [filterChangeCounter, setFilterChangeCounter] = useState(0);
  const [filterChangeCounterViolations, setFilterChangeCounterViolations] = useState(0);
  const [localPrescriptions, setLocalPrescriptions] = useState<any[]>([]);
  const [localViolations, setLocalViolations] = useState<any[]>([]);
  const [localActions, setLocalActions] = useState<any[]>([]);

  const [isLoadingActions, setIsLoadingActions] = useState(false);
  const [getActions, setGetActions] = useState(false);
  const [nextPageActions, setNextPageActions] = useState<SP.ListItemCollectionPosition | undefined>(undefined);

  const itemsPerPage = 75;

  const directionFilterData = useAppSelector((state: any) => selectModelData(state, 'gos-directions'));
  const locationMappingData = useAppSelector((state: any) => selectModelData(state, 'gos-locations'));
  const prescriptionsData = useAppSelector((state: any) => selectModelData(state, 'gos-prescriptions'));
  const ViolationsGos = useAppSelector((state: any) => selectModelData(state, 'gos-violations'));

  const prescriptionsLoading = useAppSelector((state: any) => state.gosStrapi.filtersData['gos-prescriptions']?.loading);
  const prescriptionsPagination = useAppSelector((state: any) => state.gosStrapi.filtersData['gos-prescriptions']?.pagination);
  const violationsLoading = useAppSelector((state: any) => state.gosStrapi.filtersData['gos-violations']?.loading);
  const violationsPagination = useAppSelector((state: any) => state.gosStrapi.filtersData['gos-violations']?.pagination);

  const hasNextPage = prescriptionsPagination ? prescriptionsPagination.page < prescriptionsPagination.pageCount : false;
  const hasNextPageViolations = violationsPagination ? violationsPagination.page < violationsPagination.pageCount : false;

  const users: any = useAppSelector(selectUsers);

  //! Получаю локации, направлений
      useEffect(() => {
        dispatch(
          fetchData(
            'gos-locations',
            {},
            {
              page: 1,
              pageSize: 100,
            }
          )
        );
        dispatch(
          fetchData(
            'gos-directions',
            {},
            {
              page: 1,
              pageSize: 100,
            }
          )
        );
      }, [dispatch]);

      const directionFilter = React.useMemo(() => transformDataForFilters(directionFilterData), [directionFilterData]);
      const locationMapping = React.useMemo(() => transformDataForFiltersInCode(locationMappingData), [locationMappingData]);
// console.log('locationMapping',locationMapping)
  const filterMappings = {
    prescriptions: {
      direction: 'Direction',
    },
  };

  const getFormattedFilters = useCallback(() => {
    const additionalFilters: AdditionalFilters = {};

    if (currentFilters.created?.startDate) {
      additionalFilters['DateVerification][$gte'] = currentFilters.created.startDate;
    }
    if (currentFilters.created?.endDate) {
      additionalFilters['DateVerification][$lte'] = currentFilters.created.endDate;
    }

    if (currentFilters.responsible && currentFilters.responsible?.selected?.length > 0) {
      additionalFilters.ResponsibleEmail = currentFilters.responsible.selected;
    }

    function isFilterKey(key: string): key is FilterKey {
      return key in currentFilters;
    }

    function isSelectionFilter(filter: FilterValue): filter is SelectionFilterValue {
      return 'selected' in filter;
    }

    Object.entries(filterMappings.prescriptions).forEach(([filterKey, mappedKey]) => {
      if (isFilterKey(filterKey) && currentFilters[filterKey] && isSelectionFilter(currentFilters[filterKey]) && currentFilters[filterKey].selectedIds?.length > 0) {
        additionalFilters[mappedKey] = currentFilters[filterKey].selectedIds;
      }
    });

    return {
      mainFilters: { ...additionalFilters },
    };
  }, [currentFilters]);

  //! изменение фильтров
  useEffect(() => {
    const filtersChanged = JSON.stringify(currentFilters) !== JSON.stringify(prevFilters);

    if (filtersChanged) {
      setPrevFilters(currentFilters);
      setCurrentPage(1);
      setCurrentPageViolations(1);
      setFilterChangeCounter((prev) => prev + 1);
      setFilterChangeCounterViolations((prev) => prev + 1);
      setLocalPrescriptions([]);
      setLocalViolations([]);
    }
  }, [currentFilters, prevFilters]);

  //! Загрузка данных prescriptions при изменении фильтров
  useEffect(() => {
    if (filterChangeCounter > 0) {
      const mainFilters = getFormattedFilters();
      const isAppend = currentPage > 1;

      dispatch(
        fetchData(
          'gos-prescriptions',
          mainFilters.mainFilters,
          {
            page: currentPage,
            pageSize: itemsPerPage,
          },
          isAppend
        )
      );
    }
  }, [dispatch, filterChangeCounter, currentPage, getFormattedFilters, itemsPerPage]);

  //! Загрузка данных violations при изменении счетчика
  useEffect(() => {
    if (filterChangeCounterViolations > 0) {
      const isAppend = currentPageViolations > 1;

      dispatch(
        fetchData(
          'gos-violations',
          {},
          {
            page: currentPageViolations,
            pageSize: itemsPerPage,
          },
          isAppend
        )
      );
    }
  }, [dispatch, filterChangeCounterViolations, currentPageViolations, itemsPerPage]);

  useEffect(() => {
    setFilterChangeCounter(1);
    setFilterChangeCounterViolations(1);
  }, []);

  //! загрузка следующей страницы prescriptions
  useEffect(() => {
    if (!prescriptionsLoading && hasNextPage && currentPage > 0) {
      setCurrentPage((prev) => prev + 1);
      setFilterChangeCounter((prev) => prev + 1);
    }
  }, [prescriptionsLoading, hasNextPage, currentPage]);

  //! загрузка следующей страницы violations
  useEffect(() => {
    if (!violationsLoading && hasNextPageViolations && currentPageViolations > 0) {
      setCurrentPageViolations((prev) => prev + 1);
      setFilterChangeCounterViolations((prev) => prev + 1);
    }
  }, [violationsLoading, hasNextPageViolations, currentPageViolations]);

  useEffect(() => {
    if (prescriptionsData && prescriptionsData.length > 0) {
      const sortedData = [...prescriptionsData].sort((a, b) => b.id - a.id);
      setLocalPrescriptions(sortedData);
    }
  }, [prescriptionsData]);

  useEffect(() => {
    if (ViolationsGos && ViolationsGos.length > 0) {
      const sortedViolations = [...ViolationsGos].sort((a, b) => b.id - a.id);
      setLocalViolations(sortedViolations);
    }
  }, [ViolationsGos]);

  useEffect(() => {
    if (!isLoadingActions && (!getActions || nextPageActions)) {
      setIsLoadingActions(true);

      getItemsRequest({
        listName: myTaskActionsListName,
        filters: { ImportantHashTag: `#${'Предписание'}*` },
        rowLimit: itemsPerPage,
        nextPage: getActions ? nextPageActions : undefined,
      })
        .then((results) => {
          const { items, nextPage: newNextPage } = results;
          const modifiedActions = modifiedItemsState(items, myTaskActionsListName);

          if (!getActions) {
            setLocalActions(modifiedActions);
            setGetActions(true);
          } else {
            setLocalActions((prev) => [...prev, ...modifiedActions]);
          }

          setNextPageActions(newNextPage || undefined);
          setIsLoadingActions(false);
        })
        .catch((error) => {
          console.error('Ошибка при загрузке действий:', error);
          setIsLoadingActions(false);
          if (!getActions) setGetActions(true);
        });
    }
  }, [nextPageActions, isLoadingActions, getActions]);

  const filterConfigs = useMemo(
    () => ({
      direction: { items: directionFilter },
    }),
    [directionFilter]
  );

  const filtersMap = useMemo(
    () => ({
      direction: directionFilter,
    }),
    [directionFilter]
  );

  const handleFiltersChange = useCallback(
    (newFilters: any) => {
      if (!isEqual(currentFilters, newFilters)) {
        setCurrentFilters(newFilters);
      }
    },
    [currentFilters]
  );

  const { generatedPrescription, prescriptionChartData, actionsChartData } = useMemo(() => {
    const generated = generatePrescriptions(localPrescriptions, localViolations, localActions, users);
    return {
      generatedPrescription: generated,
      prescriptionChartData: transformPrescriptionsToChartData(generated, currentFilters, locationMapping),
      actionsChartData: transformActionsToChartData(generated, currentFilters, locationMapping),
    };
  }, [localPrescriptions, localViolations, localActions, currentFilters, users, locationMapping]);

  return (
    <div className='flex justify-between w-full h-full'>
      <div className='w-[320px] mr-2 bg-white'>
        <FilterForPlanAction
          onFiltersChange={handleFiltersChange}
          filterConfigs={filterConfigs}
          filtersMap={filtersMap}
          initialFilters={initialFilterReportPres}
          filtersOpen={initialFilterOpenReportPres}
          filtersConfig={filterConfigReportPres}
          responsibleFil={true}
          heightFilter={'h-[calc(100vh-10px)]'}
        />
      </div>
      <div className='flex-1 min-w-0 m-6'>
        <div className='flex items-center text-gray-600 mb-6'>
          <span className='pr-3'>
            <ReportIcon />
          </span>
          <span className='cursor-pointer text-base' onClick={() => navigate('/dashboard/4/reports')}>
            Отчеты
          </span>
          <span className='mx-2'>→</span>
          <span className='text-base'>Отчет по предписаниям</span>
        </div>
        <div className='min-w-0'>
          <h2 className='font-medium mb-4'>Статус по предписаниям</h2>
          <PanelStatus data={generatedPrescription} />
          <ChartLicense data={prescriptionChartData} labels={LabelsPrescription} />
          <h2 className='font-medium my-4'>Статус действий по предписаниям</h2>
          <ChartLicense data={actionsChartData} labels={LabelsActions} />
        </div>
      </div>
    </div>
  );
}

export default ReportPrescription;
